import React from 'react';
import { Route, Switch } from 'react-router-dom';
import UserManagementPage from './UserManagementPage';

const UserPages = () => {
  return (
    <Switch>
      <Route component={UserManagementPage} exact path="" />
    </Switch>
  );
};

export default UserPages;
